/* global window */
import { queryStringToParams, paramsToQueryString } from 'Helpers/url';
import { CampaingHelpers } from 'olx-autos-landing-page';
import { BOOKING_ROUTES } from 'Autos/constants';

export const movedPermanently = () => {
    const status = 301;

    return { status };
};

export const NOT_FOUND = { status: 404 };

export const movedTemporarily = () => {
    const status = 302;

    return { status };
};

export const maxPage = (location, replace) => {
    const maxpage = 999;
    const { page } = location.query;

    if (page && page > maxpage) {
        const searchPath = location.search.replace(/page=[0-9]+/, 'page=999');

        replace({
            pathname: searchPath,
            state: movedPermanently()
        });
    }
};

export const getLanguageBasePath = params => {
    if (params && params.lang) {
        return `/${params.lang}`;
    }
    return '';
};

export const checkLangPathParam = (firstPathParam, langs) => {
    const lang = langs?.find(({ param }) => param && param?.toLowerCase() === firstPathParam?.toLowerCase());

    return !!lang;
};

export const checkLangPathParamLocale = (firstPathParam, langs) => {
    const lang = langs?.find(({ locale }) => locale && locale?.toLowerCase() === firstPathParam?.toLowerCase());

    return !!lang;
};

export const getPathParam = configLangs => {
    if (typeof window === 'undefined') {
        return null;
    }

    const { pathname } = window.self.location;
    const firstPathParam = pathname.split('/')[1];

    if (checkLangPathParam(firstPathParam, configLangs) || checkLangPathParamLocale(firstPathParam, configLangs)) {
        return firstPathParam;
    }

    return null;
};

export const checkFeature = featureFlag => (_, replace) => {
    if (!featureFlag) {
        replace({
            pathname: '/notfound',
            state: movedPermanently()
        });
    }
};

export const inspectionFeature = (device, replace, state, Auth) => {
    if (device === 'desktop') {
        replace({
            pathname: '/',
            state: movedPermanently()
        });
    }
    else {
        const searchParam = state.location.search || '';
        const param = queryStringToParams(searchParam.split('?')[1]);

        if (param.phone) {
            param.login_method = 'phone';
            param.login_value = param.phone;
            delete param.phone;
            const pathname = `/inspection/consent/?${paramsToQueryString(param)}`;

            replace({
                pathname,
                state: movedPermanently()
            });
        }
        else {
            Auth.requiresAuth(state, replace);
        }
    }
};

export const getIsBlackListedPath = (nextState, config) => {
    if (!nextState) {
        return false;
    }

    const isPaidCampaign = CampaingHelpers.isPaidCampaign(nextState.location.query, config);
    /**
     * Should not show location onboarding for the route
     * Starts with 'book-appointment'
     */
    const isBookingFlow = nextState.location.pathname.includes(BOOKING_ROUTES.BOOK_APPOINTMENT);

    return isPaidCampaign || isBookingFlow;
};

export const isHPWidgetized = config => {
    const { olxAutos = {}} = config;

    return !!olxAutos.isHomePageWidgetized;
};

export const getConditionalRoute = (route, condition) => {
    if (!condition) {
        return [];
    }
    return [route];
};
